var _circle, _circle2, _rect, _path, _path2, _path3, _g, _rect2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect3, _rect4, _g2, _path17, _path18, _path19, _path20, _rect5, _path21, _rect6, _rect7, _path22, _path23, _path24, _rect8, _path25, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _path26, _g3, _rect16, _rect17, _path27, _g4, _rect18, _path28, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _path29, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _path30, _g5, _g6, _path31, _path32, _path33, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPointCarMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#3A8A7A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 20,
    cy: 20,
    r: 10,
    fill: "#3A8A7A"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18296_168274)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.4214,
    y: 3.18457,
    width: 32.1187,
    height: 11.0754,
    transform: "rotate(90 25.4214 3.18457)",
    fill: "url(#pattern0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5291 10.9111H19.5268C19.4793 10.9111 19.4409 10.9496 19.4409 10.997V11.0607C19.4409 11.1081 19.4793 11.1465 19.5268 11.1465H20.5291C20.5765 11.1465 20.6149 11.1081 20.6149 11.0607V10.997C20.6149 10.9496 20.5765 10.9111 20.5291 10.9111Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.043 10.9971H20.0112C19.9875 10.9971 19.9683 11.0163 19.9683 11.04V11.2573C19.9683 11.281 19.9875 11.3003 20.0112 11.3003H20.043C20.0667 11.3003 20.0859 11.281 20.0859 11.2573V11.04C20.0859 11.0163 20.0667 10.9971 20.043 10.9971Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3722 11.3268C18.3722 11.2617 18.4497 11.2022 18.5425 11.2022H21.5135C21.5549 11.2015 21.5953 11.2148 21.6282 11.2399C21.6611 11.265 21.6846 11.3005 21.6948 11.3406C21.6948 11.3406 18.3722 11.3323 18.3722 11.3268Z",
    fill: "#333333"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2484 7.98397V7.97151C16.2296 7.89514 16.2268 7.81571 16.2402 7.73821C16.2536 7.66071 16.2828 7.58681 16.3261 7.52115C16.3694 7.4555 16.4258 7.3995 16.4918 7.35669C16.5577 7.31388 16.6319 7.28517 16.7095 7.27237C17.517 7.11801 18.3402 7.06176 19.1613 7.10485C19.2412 7.1063 19.3201 7.12411 19.3929 7.15719C19.4657 7.19027 19.531 7.23792 19.5847 7.2972C19.6384 7.35648 19.6794 7.42614 19.7052 7.50187C19.7309 7.5776 19.7409 7.65781 19.7344 7.73754V7.75C18.5679 7.614 17.3863 7.6933 16.2484 7.98397Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7803 7.6835C18.5796 7.53919 17.3625 7.6209 16.1918 7.92439V7.95346C17.3591 7.64953 18.5732 7.56828 19.7706 7.71396L19.7803 7.6835Z",
    fill: "url(#paint0_linear_18296_168274)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7856 7.6323C18.5762 7.48542 17.3499 7.56761 16.1709 7.87458V7.90365C17.3449 7.59798 18.566 7.51579 19.7704 7.66138L19.7856 7.6323Z",
    fill: "url(#paint1_linear_18296_168274)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.791 7.58048C18.5773 7.43498 17.3471 7.51761 16.1638 7.82414L16.1721 7.85321C17.3516 7.5464 18.5783 7.46421 19.7882 7.61094L19.791 7.58048Z",
    fill: "url(#paint2_linear_18296_168274)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7969 7.52868C18.5772 7.38152 17.3407 7.46464 16.1517 7.77372V7.8028C17.3374 7.49373 18.5707 7.4106 19.7872 7.55775L19.7969 7.52868Z",
    fill: "url(#paint3_linear_18296_168274)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8022 7.47596C18.576 7.32834 17.3329 7.4124 16.1377 7.72377V7.75146C17.3299 7.44168 18.5697 7.35856 19.7926 7.50642L19.8022 7.47596Z",
    fill: "url(#paint4_linear_18296_168274)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8091 7.43051C18.5759 7.28221 17.3259 7.36626 16.1237 7.67832L16.132 7.70739C17.33 7.39534 18.5759 7.31127 19.8049 7.45958L19.8091 7.43051Z",
    fill: "url(#paint5_linear_18296_168274)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8149 7.3729C18.5752 7.22414 17.3186 7.30914 16.1102 7.62348L16.1185 7.65117C17.3228 7.33772 18.5754 7.25366 19.8108 7.40336L19.8149 7.3729Z",
    fill: "url(#paint6_linear_18296_168274)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8203 7.32097C18.5748 7.16993 17.3121 7.25399 16.0976 7.56879V7.59786C17.3082 7.28287 18.5672 7.19788 19.8092 7.34728L19.8203 7.32097Z",
    fill: "url(#paint7_linear_18296_168274)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8257 7.26858C18.5748 7.11913 17.307 7.20505 16.0877 7.52193V7.54962C17.3047 7.23321 18.5704 7.14821 19.8188 7.29904L19.8257 7.26858Z",
    fill: "url(#paint8_linear_18296_168274)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8315 7.21752C18.5729 7.06549 17.2969 7.15143 16.0701 7.47087L16.0784 7.49995C17.3016 7.18118 18.5738 7.09524 19.8288 7.24659L19.8315 7.21752Z",
    fill: "url(#paint9_linear_18296_168274)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8369 7.16478C18.5717 7.01232 17.2891 7.09921 16.056 7.4209L16.0643 7.44997C17.2939 7.1296 18.5726 7.04273 19.8341 7.19385L19.8369 7.16478Z",
    fill: "url(#paint10_linear_18296_168274)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7441 7.74449V7.76941C18.5725 7.63099 17.3854 7.71079 16.2429 8.00477V7.97985C16.2232 7.90191 16.2201 7.82073 16.2335 7.74149C16.247 7.66225 16.2768 7.58669 16.3211 7.51961C16.3654 7.45254 16.4231 7.39542 16.4907 7.35191C16.5583 7.30839 16.6342 7.27943 16.7136 7.26687C17.5215 7.11181 18.3453 7.05556 19.1668 7.09935C19.2478 7.10171 19.3274 7.12053 19.4009 7.15467C19.4743 7.1888 19.54 7.23753 19.5941 7.29789C19.6481 7.35825 19.6892 7.42897 19.715 7.50576C19.7408 7.58254 19.7507 7.66377 19.7441 7.74449ZM19.7206 7.74449C19.7266 7.66644 19.7167 7.58798 19.6913 7.51391C19.6659 7.43985 19.6257 7.37176 19.573 7.31381C19.5204 7.25586 19.4565 7.20927 19.3852 7.17692C19.3139 7.14456 19.2368 7.12712 19.1585 7.12566C18.3384 7.0821 17.5161 7.13788 16.7094 7.29179C16.6329 7.30347 16.5597 7.33106 16.4946 7.37278C16.4294 7.41449 16.3737 7.4694 16.331 7.53397C16.2884 7.59854 16.2597 7.67133 16.2469 7.74765C16.2341 7.82397 16.2375 7.90213 16.2567 7.97708C17.3875 7.68897 18.5613 7.60968 19.7206 7.74311V7.74449Z",
    fill: "url(#paint11_linear_18296_168274)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5908,
    y: 3.18457,
    width: 1.24599,
    height: 9.55255,
    transform: "rotate(90 24.5908 3.18457)",
    fill: "url(#pattern1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5316 4.71151V4.69767C17.5316 4.37787 17.8874 4.11621 18.3221 4.11621L21.419 4.11621C21.8538 4.11621 22.2109 4.37787 22.2109 4.69767V4.71151L17.5316 4.71151Z",
    fill: "#323232"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2636 4.63379H17.479V4.66286H22.2636V4.63379Z",
    fill: "url(#paint12_linear_18296_168274)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2636 4.58301H17.479V4.61208H22.2636V4.58301Z",
    fill: "url(#paint13_linear_18296_168274)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2621 4.53027H17.4775V4.55935H22.2621V4.53027Z",
    fill: "url(#paint14_linear_18296_168274)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2636 4.47754H17.479V4.50661H22.2636V4.47754Z",
    fill: "url(#paint15_linear_18296_168274)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2636 4.42676H17.479V4.45583H22.2636V4.42676Z",
    fill: "url(#paint16_linear_18296_168274)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2621 4.37402H17.4775V4.4031H22.2621V4.37402Z",
    fill: "url(#paint17_linear_18296_168274)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2621 4.32129H17.4775V4.35036H22.2621V4.32129Z",
    fill: "url(#paint18_linear_18296_168274)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2636 4.27051H17.479V4.29958H22.2636V4.27051Z",
    fill: "url(#paint19_linear_18296_168274)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2636 4.21777H17.479V4.24685H22.2636V4.21777Z",
    fill: "url(#paint20_linear_18296_168274)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2621 4.16504H17.4775V4.19411H22.2621V4.16504Z",
    fill: "url(#paint21_linear_18296_168274)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2636 4.1123H17.479V4.14138H22.2636V4.1123Z",
    fill: "url(#paint22_linear_18296_168274)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2275 4.69816V4.72447L17.5136 4.72447V4.69816C17.5136 4.37144 17.8763 4.1084 18.3221 4.1084L21.419 4.1084C21.8648 4.1084 22.2275 4.37144 22.2275 4.69816ZM22.1929 4.69816C22.1929 4.38528 21.8454 4.13055 21.419 4.13055L18.3221 4.13055C17.8957 4.13055 17.5482 4.38528 17.5482 4.69816L22.1929 4.69816Z",
    fill: "url(#paint23_linear_18296_168274)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.8677,
    y: 4.29199,
    width: 0.553771,
    height: 0.9691,
    transform: "rotate(90 24.8677 4.29199)",
    fill: "url(#pattern2)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.8691,
    y: 4.29199,
    width: 0.692214,
    height: 1.10754,
    transform: "rotate(90 15.8691 4.29199)",
    fill: "url(#pattern3)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8991 33.5048H22.7994C22.6158 33.5048 22.4398 33.4319 22.3099 33.302C22.1801 33.1722 22.1072 32.9962 22.1072 32.8126L22.1072 13.533C22.1072 13.3494 22.1801 13.1734 22.3099 13.0436C22.4398 12.9137 22.6158 12.8408 22.7994 12.8408H22.8991C23.0827 12.8408 23.2587 12.9137 23.3886 13.0436C23.5184 13.1734 23.5913 13.3494 23.5913 13.533L23.5913 32.8181C23.5898 33.0007 23.5163 33.1754 23.3866 33.304C23.257 33.4326 23.0817 33.5048 22.8991 33.5048ZM22.218 32.8126C22.2183 32.9667 22.2797 33.1144 22.3887 33.2233C22.4976 33.3323 22.6453 33.3937 22.7994 33.394H22.8991C23.0531 33.3937 23.2006 33.3322 23.3094 33.2232C23.4181 33.1142 23.4792 32.9666 23.4792 32.8126L23.4792 13.533C23.4792 13.3791 23.4181 13.2314 23.3094 13.1224C23.2006 13.0134 23.0531 12.9519 22.8991 12.9516H22.7994C22.6453 12.9519 22.4976 13.0133 22.3887 13.1223C22.2797 13.2312 22.2183 13.3789 22.218 13.533L22.218 32.8126Z",
    fill: "url(#paint24_linear_18296_168274)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8156 33.5048H20.7159C20.5323 33.5048 20.3563 33.4319 20.2265 33.302C20.0966 33.1722 20.0237 32.9962 20.0237 32.8126L20.0237 13.533C20.0237 13.3494 20.0966 13.1734 20.2265 13.0436C20.3563 12.9137 20.5323 12.8408 20.7159 12.8408H20.8156C20.9992 12.8408 21.1753 12.9137 21.3051 13.0436C21.4349 13.1734 21.5078 13.3494 21.5078 13.533L21.5078 32.8181C21.5064 33.0007 21.4328 33.1754 21.3031 33.304C21.1735 33.4326 20.9982 33.5048 20.8156 33.5048ZM20.1345 32.8126C20.1348 32.9667 20.1962 33.1144 20.3052 33.2233C20.4141 33.3323 20.5618 33.3937 20.7159 33.394H20.8156C20.9697 33.3937 21.1174 33.3323 21.2263 33.2233C21.3353 33.1144 21.3967 32.9667 21.3971 32.8126L21.3971 13.533C21.3967 13.3789 21.3353 13.2312 21.2263 13.1223C21.1174 13.0133 20.9697 12.9519 20.8156 12.9516H20.7159C20.5618 12.9519 20.4141 13.0133 20.3052 13.1223C20.1962 13.2312 20.1348 13.3789 20.1345 13.533L20.1345 32.8126Z",
    fill: "url(#paint25_linear_18296_168274)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7321 33.5048H18.6324C18.4488 33.5048 18.2728 33.4319 18.143 33.302C18.0131 33.1722 17.9402 32.9962 17.9402 32.8126L17.9402 13.533C17.9402 13.3494 18.0131 13.1734 18.143 13.0436C18.2728 12.9137 18.4488 12.8408 18.6324 12.8408H18.7321C18.9157 12.8408 19.0918 12.9137 19.2216 13.0436C19.3514 13.1734 19.4243 13.3494 19.4243 13.533L19.4243 32.8181C19.4229 33.0007 19.3493 33.1754 19.2196 33.304C19.09 33.4326 18.9147 33.5048 18.7321 33.5048ZM18.051 32.8126C18.0513 32.9667 18.1127 33.1144 18.2217 33.2233C18.3306 33.3323 18.4783 33.3937 18.6324 33.394H18.7321C18.8862 33.3937 19.0339 33.3323 19.1429 33.2233C19.2518 33.1144 19.3132 32.9667 19.3136 32.8126L19.3136 13.533C19.3132 13.3789 19.2518 13.2312 19.1429 13.1223C19.0339 13.0133 18.8862 12.9519 18.7321 12.9516H18.6324C18.4783 12.9519 18.3306 13.0133 18.2217 13.1223C18.1127 13.2312 18.0513 13.3789 18.051 13.533L18.051 32.8126Z",
    fill: "url(#paint26_linear_18296_168274)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6486 33.5048H16.5489C16.3653 33.5048 16.1893 33.4319 16.0595 33.302C15.9296 33.1722 15.8567 32.9962 15.8567 32.8126L15.8567 13.533C15.8567 13.3494 15.9296 13.1734 16.0595 13.0436C16.1893 12.9137 16.3653 12.8408 16.5489 12.8408H16.6486C16.8322 12.8408 17.0083 12.9137 17.1381 13.0436C17.2679 13.1734 17.3408 13.3494 17.3408 13.533L17.3408 32.8181C17.3394 33.0007 17.2658 33.1754 17.1361 33.304C17.0065 33.4326 16.8312 33.5048 16.6486 33.5048ZM15.9689 32.8126C15.9689 32.9666 16.0299 33.1142 16.1387 33.2232C16.2474 33.3322 16.395 33.3937 16.5489 33.394H16.6486C16.8027 33.3937 16.9504 33.3323 17.0594 33.2233C17.1683 33.1144 17.2297 32.9667 17.2301 32.8126L17.2301 13.533C17.2297 13.3789 17.1683 13.2312 17.0594 13.1223C16.9504 13.0133 16.8027 12.9519 16.6486 12.9516H16.5489C16.395 12.9519 16.2474 13.0134 16.1387 13.1224C16.0299 13.2314 15.9689 13.3791 15.9689 13.533L15.9689 32.8126Z",
    fill: "url(#paint27_linear_18296_168274)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7198 15.1099C24.7198 14.2612 25.0396 14.5339 25.0396 14.5339C25.0729 14.5339 25.0964 14.5949 25.1089 14.7208C25.1255 14.8759 25.1255 15.1085 25.1255 15.3314V15.4601L25.1587 33.873L25.1504 33.891L25.1158 15.4601V15.3369C25.1158 15.1196 25.1158 14.9216 25.1019 14.7831C25.0909 14.6738 25.0701 14.6198 25.0382 14.6198C25.0382 14.6198 24.7267 14.401 24.7267 15.1182L24.7544 33.8592H24.7461L24.7198 15.1099Z",
    fill: "url(#paint28_linear_18296_168274)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9248 15.1099C14.9248 14.2612 14.605 14.5339 14.605 14.5339C14.5718 14.5339 14.5482 14.5949 14.5358 14.7208C14.5192 14.8759 14.5192 15.1085 14.5206 15.3314V15.4601L14.4887 33.8896L14.497 33.9076L14.5233 15.4601V15.3369C14.5233 15.1196 14.5233 14.9216 14.5358 14.7831C14.5482 14.6738 14.569 14.6198 14.5995 14.6198C14.5995 14.6198 14.911 14.401 14.911 15.1182L14.8833 33.8702H14.8916L14.9248 15.1099Z",
    fill: "url(#paint29_linear_18296_168274)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4962 34.9255C15.6406 34.9145 15.4675 34.8688 15.4675 34.7996V34.3718C15.4675 34.3233 15.5243 34.2901 15.6433 34.2693C15.9607 34.2377 16.2799 34.2275 16.5986 34.2389H16.7675C17.5608 34.2389 19.8132 34.2389 19.834 34.2389C20.2106 34.2389 21.0315 34.2389 21.8262 34.2389C22.4852 34.2389 23.1082 34.2458 23.4529 34.2458C24.2309 34.2458 24.2489 34.3081 24.2614 34.3441C24.2711 34.4096 24.2757 34.4758 24.2753 34.5421C24.2753 34.6168 24.2753 34.7013 24.2877 34.7622C24.3029 34.9006 23.853 34.9117 23.1068 34.9214C22.3606 34.9311 20.2272 34.9975 19.834 34.9975C19.4408 34.9975 17.2908 34.9352 16.4962 34.9255ZM19.8368 34.2527C19.8132 34.2527 17.5622 34.2527 16.7675 34.2527H16.5972C16.3044 34.2418 16.0112 34.2502 15.7195 34.2776C15.6212 34.2942 15.581 34.3219 15.581 34.3662V34.794C15.581 34.8466 15.6503 34.8909 16.5086 34.9006C17.2493 34.9103 19.4519 34.9782 19.8409 34.9782C20.23 34.9782 22.3675 34.9131 23.1054 34.9034C23.8433 34.8937 24.2005 34.8882 24.188 34.765C24.188 34.704 24.1783 34.6196 24.1756 34.5448C24.1751 34.4791 24.1705 34.4134 24.1617 34.3482C24.1507 34.3122 24.1368 34.2666 23.4612 34.2666C23.1151 34.2666 22.4921 34.2666 21.8317 34.2666C21.1395 34.2666 20.4169 34.2596 20.0001 34.2596C19.9337 34.2513 19.8811 34.2527 19.8368 34.2527Z",
    fill: "url(#paint30_linear_18296_168274)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2847 13.6686V13.5869H24.2727V13.6686H25.2847Z",
    fill: "url(#paint31_linear_18296_168274)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20.0225,
    y: 33.9189,
    width: 1.24599,
    height: 0.276886,
    transform: "rotate(90 20.0225 33.9189)",
    fill: "url(#pattern4)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1704 13.5905L14.4146 13.582L14.4136 13.6637L15.1695 13.6722L15.1704 13.5905Z",
    fill: "url(#paint32_linear_18296_168274)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24.314,
    y: 5.67676,
    width: 28.2423,
    height: 0.692214,
    transform: "rotate(90 24.314 5.67676)",
    fill: "url(#pattern5)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 15.8691,
    y: 5.67676,
    width: 28.2423,
    height: 0.830657,
    transform: "rotate(90 15.8691 5.67676)",
    fill: "url(#pattern6)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2212 9.48403V9.40234H25.2027L25.2041 9.48403H24.2212Z",
    fill: "url(#paint33_linear_18296_168274)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4913 9.48403L14.4941 9.40234H15.2334V9.48403H14.4913Z",
    fill: "url(#paint34_linear_18296_168274)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M15.0454 12.1503C15.0357 12.3317 15.0247 12.5656 15.0025 12.8315C14.9721 13.1706 14.9582 13.3312 14.8765 13.3105C14.7971 13.2744 14.7253 13.2237 14.6647 13.161C14.5807 12.9851 14.5381 12.7924 14.5401 12.5975C14.5401 12.2652 14.572 10.7576 14.6315 10.2301C14.6606 9.97677 14.8696 10.0252 14.8848 10.0335C14.9354 10.2097 14.9638 10.3916 14.9693 10.5748C15.0332 11.0974 15.0587 11.624 15.0454 12.1503Z",
    fill: "#58717A"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1768,
    y: 9.96875,
    width: 3.46107,
    height: 0.692214,
    transform: "rotate(90 15.1768 9.96875)",
    fill: "url(#pattern7)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M24.689 12.1503C24.6986 12.3317 24.7097 12.5656 24.7333 12.8315C24.7623 13.1706 24.7762 13.3312 24.8579 13.3105C24.9372 13.2744 25.0091 13.2237 25.0697 13.161C25.1537 12.9851 25.1963 12.7924 25.1943 12.5975C25.1943 12.2652 25.1624 10.7576 25.1029 10.2301C25.0738 9.97677 24.8648 10.0252 24.8495 10.0335C24.7989 10.2097 24.7706 10.3916 24.7651 10.5748C24.7012 11.0974 24.6757 11.624 24.689 12.1503Z",
    fill: "#58717A"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 25.2832,
    y: 9.96875,
    width: 3.46107,
    height: 0.692214,
    transform: "rotate(90 25.2832 9.96875)",
    fill: "url(#pattern8)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 25.5601,
    y: 9.55273,
    width: 0.276886,
    height: 0.830657,
    transform: "rotate(90 25.5601 9.55273)",
    fill: "url(#pattern9)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 26.1138,
    y: 9.55273,
    width: 0.553771,
    height: 1.10754,
    transform: "rotate(90 26.1138 9.55273)",
    fill: "url(#pattern10)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7612,
    y: 9.55273,
    width: 0.276886,
    height: 0.830657,
    transform: "rotate(90 14.7612 9.55273)",
    fill: "url(#pattern11)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 14.4844,
    y: 9.41406,
    width: 0.553771,
    height: 1.10754,
    transform: "rotate(90 14.4844 9.41406)",
    fill: "url(#pattern12)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 24.8677,
    y: 34.1953,
    width: 0.553771,
    height: 0.553771,
    transform: "rotate(90 24.8677 34.1953)",
    fill: "url(#pattern13)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 24.8677,
    y: 34.4727,
    width: 0.276886,
    height: 0.415328,
    transform: "rotate(90 24.8677 34.4727)",
    fill: "url(#pattern14)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6049 34.4273L24.7544 34.4342V34.4038L24.7447 34.3193H24.6436L24.6049 34.4273Z",
    fill: "#BE0805"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6783 34.2591L24.5731 34.2522L24.5759 34.248L24.6797 34.2536L24.6783 34.2591Z",
    fill: "#FF6363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6729 34.2732L24.5677 34.2663L24.5705 34.2607L24.6743 34.2677L24.6729 34.2732Z",
    fill: "#FF6363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6671 34.2855L24.5619 34.2786L24.5646 34.2744L24.6685 34.28L24.6671 34.2855Z",
    fill: "#FF6363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6617 34.2996L24.5565 34.2926L24.5593 34.2871L24.6631 34.294L24.6617 34.2996Z",
    fill: "#FF6363"
  }))), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1768,
    y: 34.1953,
    width: 0.553771,
    height: 0.553771,
    transform: "rotate(90 15.1768 34.1953)",
    fill: "url(#pattern15)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 15.0386,
    y: 34.4727,
    width: 0.276886,
    height: 0.415328,
    transform: "rotate(90 15.0386 34.4727)",
    fill: "url(#pattern16)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9097 34.4478H14.7712V34.4188L14.7823 34.3398H14.882L14.9097 34.4478Z",
    fill: "#BE0805"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8347 34.2913L14.9399 34.2858L14.9372 34.2803L14.8333 34.2872L14.8347 34.2913Z",
    fill: "#FF6363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8401 34.304L14.9453 34.2985L14.9425 34.293L14.8387 34.2999L14.8401 34.304Z",
    fill: "#FF6363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.846 34.3167L14.9512 34.3112L14.9484 34.3057L14.8446 34.3126L14.846 34.3167Z",
    fill: "#FF6363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8513 34.3285L14.9565 34.3215L14.9538 34.3174L14.8499 34.3229L14.8513 34.3285Z",
    fill: "#FF6363"
  }))), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 24.314,
    y: 8.03027,
    width: 3.59951,
    height: 9.13722,
    transform: "rotate(90 24.314 8.03027)",
    fill: "url(#pattern17)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M15.3291 9.45171C15.3554 9.29527 15.4675 8.96439 15.606 8.88132C16.5072 8.32755 18.804 8.41754 19.8534 8.38154C20.1428 8.37185 20.5041 8.36909 20.8945 8.38154C21.9314 8.412 23.1747 8.53937 23.8239 8.88132H23.8336C23.9555 8.95747 24.0745 9.23851 24.1022 9.37556C24.1881 9.80889 24.1022 11.0037 24.0593 11.5796C24.1119 11.5879 24.1396 11.5934 24.1396 11.5934C24.1396 11.5934 24.3279 9.65522 24.2116 9.06822C24.1839 8.92978 24.0607 8.65289 23.9347 8.57398C23.9347 8.57398 23.9347 8.57398 23.9236 8.57398C23.2605 8.23341 21.9854 8.10466 20.9222 8.0742C20.5221 8.06313 20.1511 8.06451 19.8562 8.0742C18.7791 8.1102 16.4256 8.01882 15.5022 8.57398C15.3637 8.65705 15.2433 8.98931 15.217 9.14575C15.1201 9.71198 15.3734 11.599 15.3734 11.599C15.3734 11.599 15.3956 11.599 15.4399 11.5879C15.3776 11.03 15.2585 9.87396 15.3291 9.45171Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.64
  }, _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 24.314,
    y: 8.03027,
    width: 3.73796,
    height: 9.27567,
    transform: "rotate(90 24.314 8.03027)",
    fill: "url(#pattern18)"
  }))), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 25.2832,
    y: 33.7803,
    width: 0.276886,
    height: 10.937,
    transform: "rotate(90 25.2832 33.7803)",
    fill: "url(#pattern19)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 24.314,
    y: 4.15332,
    width: 1.66131,
    height: 2.21508,
    transform: "rotate(90 24.314 4.15332)",
    fill: "url(#pattern20)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    }
  }, _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 24.1758,
    y: 5.12305,
    width: 0.553771,
    height: 0.692214,
    transform: "rotate(90 24.1758 5.12305)",
    fill: "url(#pattern21)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    }
  }, _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 23.7603,
    y: 4.70703,
    width: 0.553771,
    height: 0.830657,
    transform: "rotate(90 23.7603 4.70703)",
    fill: "url(#pattern22)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    }
  }, _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 23.2065,
    y: 4.29199,
    width: 0.553771,
    height: 0.692214,
    transform: "rotate(90 23.2065 4.29199)",
    fill: "url(#pattern23)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 24.314,
    y: 4.15332,
    width: 1.66131,
    height: 2.21508,
    transform: "rotate(90 24.314 4.15332)",
    fill: "url(#pattern24)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.46
  }, _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 24.314,
    y: 4.15332,
    width: 1.66131,
    height: 2.21508,
    transform: "rotate(90 24.314 4.15332)",
    fill: "url(#pattern25)"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M23.5845 4.7519C23.4543 4.60346 23.3048 4.47309 23.1401 4.36426C23.2305 4.38527 23.3197 4.41115 23.4073 4.44179C23.4823 4.49805 23.5544 4.55812 23.6233 4.62176L23.7326 4.72698C23.8115 4.80312 23.8711 4.86542 23.8932 4.88896L23.9915 4.99833C24.0385 5.04589 24.0778 5.10055 24.1078 5.1603C24.1352 5.21714 24.1662 5.27217 24.2006 5.32505C24.2359 5.36933 24.2585 5.4225 24.2656 5.47872V5.48564C24.2282 5.55758 24.1656 5.61325 24.0898 5.64208C24.0588 5.65518 24.0269 5.66582 23.9943 5.67393C23.9664 5.32895 23.8219 5.00374 23.5845 4.7519Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5303,
    y: 4.15332,
    width: 1.66131,
    height: 2.21508,
    transform: "rotate(90 17.5303 4.15332)",
    fill: "url(#pattern26)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    }
  }, _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2842,
    y: 5.12305,
    width: 0.553771,
    height: 0.830657,
    transform: "rotate(90 16.2842 5.12305)",
    fill: "url(#pattern27)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    }
  }, _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 16.6997,
    y: 4.70703,
    width: 0.553771,
    height: 0.830657,
    transform: "rotate(90 16.6997 4.70703)",
    fill: "url(#pattern28)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    }
  }, _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 17.1147,
    y: 4.29199,
    width: 0.553771,
    height: 0.553771,
    transform: "rotate(90 17.1147 4.29199)",
    fill: "url(#pattern29)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5303,
    y: 4.15332,
    width: 1.66131,
    height: 2.21508,
    transform: "rotate(90 17.5303 4.15332)",
    fill: "url(#pattern30)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.46
  }, _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5303,
    y: 4.15332,
    width: 1.66131,
    height: 2.21508,
    transform: "rotate(90 17.5303 4.15332)",
    fill: "url(#pattern31)"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M16.0947 4.7519C16.2249 4.60346 16.3743 4.47309 16.5391 4.36426C16.4487 4.38527 16.3595 4.41115 16.2719 4.44179C16.2068 4.48886 16.1334 4.55531 16.0559 4.62176L15.9465 4.72698C15.8676 4.80312 15.8081 4.86542 15.7873 4.88896L15.6876 4.99833C15.6406 5.04589 15.6014 5.10055 15.5713 5.1603C15.5422 5.21729 15.5093 5.27232 15.4731 5.32505C15.4383 5.36968 15.4158 5.42268 15.408 5.47872V5.48564C15.4457 5.55734 15.5082 5.61292 15.5838 5.64208C15.6148 5.65518 15.6467 5.66582 15.6793 5.67393C15.7087 5.32825 15.8552 5.00296 16.0947 4.7519Z",
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M25.2568 33.5267V30.3037H14.4306V33.5267H25.2568Z",
    fill: "#030F29"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M25.2568 30.3092V30.042H14.4306V30.3092H25.2568Z",
    fill: "#030F29"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3027 16.4913V15.8447L14.3962 15.8447V16.4913H25.3027Z",
    fill: "#48AC98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3027 15.8448V15.3506L14.3962 15.3506V15.8448L25.3027 15.8448Z",
    fill: "#5032C8"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8354 18.3267C20.3829 17.8878 19.6581 17.8916 19.2103 18.3353C18.7626 18.779 18.7587 19.4971 19.2016 19.9455L22.0189 22.7371C22.3097 23.0315 22.7377 23.1484 23.1396 23.0432C23.5416 22.938 23.8555 22.6269 23.9617 22.2287C24.0678 21.8304 23.9499 21.4063 23.6528 21.1182L20.8354 18.3267Z",
    fill: "url(#paint35_linear_18296_168274)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M17.99 19.5134C17.698 19.2179 17.2681 19.1005 16.8644 19.2061C16.4608 19.3117 16.1455 19.624 16.0389 20.0239C15.9322 20.4238 16.0507 20.8496 16.3491 21.1389L19.1787 23.9422C19.6358 24.3625 20.3467 24.3496 20.788 23.913C21.2293 23.4764 21.2433 22.7723 20.8196 22.3189L17.99 19.5134Z",
    fill: "url(#paint36_linear_18296_168274)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1792 19.147C21.1792 18.5135 20.6626 18 20.0254 18C19.3881 18 18.8716 18.5135 18.8716 19.147V23.1028C18.8716 23.7363 19.3881 24.2498 20.0254 24.2498C20.6626 24.2498 21.1792 23.7363 21.1792 23.1028V19.147Z",
    fill: "url(#paint37_linear_18296_168274)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_18296_168274",
    transform: "scale(0.00431034 0.0125)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_18296_168274",
    transform: "scale(0.111111 0.0144928)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image2_18296_168274",
    transform: "scale(0.25 0.142857)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image3_18296_168274",
    transform: "scale(0.2 0.125)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern4",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image4_18296_168274",
    transform: "scale(0.111111 0.5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern5",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image5_18296_168274",
    transform: "scale(0.00490196 0.2)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern6",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image6_18296_168274",
    transform: "scale(0.00490196 0.166667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern7",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image7_18296_168274",
    transform: "scale(0.04 0.2)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern8",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image8_18296_168274",
    transform: "scale(0.04 0.2)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern9",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image9_18296_168274",
    transform: "scale(0.5 0.166667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern10",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image10_18296_168274",
    transform: "scale(0.25 0.125)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern11",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image11_18296_168274",
    transform: "scale(0.5 0.166667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern12",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image12_18296_168274",
    transform: "scale(0.25 0.125)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern13",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image13_18296_168274",
    transform: "scale(0.25)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern14",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image14_18296_168274",
    transform: "scale(0.5 0.333333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern15",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image15_18296_168274",
    transform: "scale(0.25)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern16",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image16_18296_168274",
    transform: "scale(0.5 0.333333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern17",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image17_18296_168274",
    transform: "scale(0.0384615 0.0151515)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern18",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image18_18296_168274",
    transform: "scale(0.037037 0.0149254)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern19",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image19_18296_168274",
    transform: "scale(0.5 0.0126582)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern20",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image20_18296_168274",
    transform: "scale(0.0833333 0.0625)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern21",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image21_18296_168274",
    transform: "scale(0.25 0.2)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern22",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image22_18296_168274",
    transform: "scale(0.25 0.166667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern23",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image23_18296_168274",
    transform: "scale(0.25 0.2)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern24",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image24_18296_168274",
    transform: "scale(0.0833333 0.0625)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern25",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image24_18296_168274",
    transform: "scale(0.0833333 0.0625)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern26",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image25_18296_168274",
    transform: "scale(0.0833333 0.0625)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern27",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image26_18296_168274",
    transform: "scale(0.25 0.166667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern28",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image27_18296_168274",
    transform: "scale(0.25 0.166667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern29",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image28_18296_168274",
    transform: "scale(0.25)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern30",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image29_18296_168274",
    transform: "scale(0.0833333 0.0625)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern31",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image29_18296_168274",
    transform: "scale(0.0833333 0.0625)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18296_168274",
    x1: 18.0265,
    y1: 7.85164,
    x2: 18.0123,
    y2: 7.64951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18296_168274",
    x1: 18.0227,
    y1: 7.80044,
    x2: 18.0085,
    y2: 7.59693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18296_168274",
    x1: 18.019,
    y1: 7.75,
    x2: 18.0046,
    y2: 7.54511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_18296_168274",
    x1: 18.0157,
    y1: 7.6982,
    x2: 18.0014,
    y2: 7.49331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_18296_168274",
    x1: 18.012,
    y1: 7.64687,
    x2: 17.9975,
    y2: 7.44059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_18296_168274",
    x1: 18.0083,
    y1: 7.59588,
    x2: 17.9938,
    y2: 7.38821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_18296_168274",
    x1: 18.0049,
    y1: 7.54381,
    x2: 17.9904,
    y2: 7.33614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_18296_168274",
    x1: 18.0012,
    y1: 7.49188,
    x2: 17.9865,
    y2: 7.28283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_18296_168274",
    x1: 17.996,
    y1: 7.44097,
    x2: 17.9814,
    y2: 7.23192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_18296_168274",
    x1: 17.9928,
    y1: 7.38991,
    x2: 17.978,
    y2: 7.17948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_18296_168274",
    x1: 17.989,
    y1: 7.33855,
    x2: 17.9742,
    y2: 7.12673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_18296_168274",
    x1: 19.7281,
    y1: 7.37464,
    x2: 16.1972,
    y2: 7.62836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_18296_168274",
    x1: 19.8713,
    y1: 4.66148,
    x2: 19.8713,
    y2: 4.6324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_18296_168274",
    x1: 19.8713,
    y1: 4.6107,
    x2: 19.8713,
    y2: 4.58162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_18296_168274",
    x1: 19.8712,
    y1: 4.55796,
    x2: 19.8712,
    y2: 4.52889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_18296_168274",
    x1: 19.8713,
    y1: 4.50523,
    x2: 19.8713,
    y2: 4.47615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_18296_168274",
    x1: 19.8713,
    y1: 4.45583,
    x2: 19.8713,
    y2: 4.42676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_18296_168274",
    x1: 19.8698,
    y1: 4.40171,
    x2: 19.8698,
    y2: 4.37264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_18296_168274",
    x1: 19.8712,
    y1: 4.34898,
    x2: 19.8712,
    y2: 4.3199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_18296_168274",
    x1: 19.8713,
    y1: 4.29958,
    x2: 19.8713,
    y2: 4.27051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_18296_168274",
    x1: 19.8713,
    y1: 4.24546,
    x2: 19.8713,
    y2: 4.21639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_18296_168274",
    x1: 19.8712,
    y1: 4.19273,
    x2: 19.8712,
    y2: 4.16365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_18296_168274",
    x1: 19.8713,
    y1: 4.13999,
    x2: 19.8713,
    y2: 4.11092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_18296_168274",
    x1: 22.2289,
    y1: 4.41436,
    x2: 17.5136,
    y2: 4.41436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_18296_168274",
    x1: 23.5844,
    y1: 23.1756,
    x2: 22.1114,
    y2: 23.1756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9C9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_18296_168274",
    x1: 21.5023,
    y1: 23.1756,
    x2: 20.0279,
    y2: 23.1756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9C9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_18296_168274",
    x1: 19.4188,
    y1: 23.1756,
    x2: 17.9457,
    y2: 23.1756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9C9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_18296_168274",
    x1: 17.3353,
    y1: 23.1756,
    x2: 15.8623,
    y2: 23.1756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9C9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_18296_168274",
    x1: 24.7198,
    y1: 24.1889,
    x2: 25.1573,
    y2: 24.1889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9C9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_18296_168274",
    x1: 14.9193,
    y1: 24.1959,
    x2: 14.4818,
    y2: 24.1959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9C9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_18296_168274",
    x1: 19.8797,
    y1: 35.0031,
    x2: 19.8797,
    y2: 34.2333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9C9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_18296_168274",
    x1: 24.778,
    y1: 13.5869,
    x2: 24.778,
    y2: 13.6686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9C9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_18296_168274",
    x1: 14.791,
    y1: 13.5848,
    x2: 14.791,
    y2: 13.6665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9C9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_18296_168274",
    x1: 24.7126,
    y1: 9.40234,
    x2: 24.7126,
    y2: 9.48403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9C9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_18296_168274",
    x1: 14.8624,
    y1: 9.40234,
    x2: 14.8624,
    y2: 9.48403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9C9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_18296_168274",
    x1: 16.9747,
    y1: 20.5322,
    x2: 21.3853,
    y2: 24.9834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#236EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#13A6C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#05D6DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_18296_168274",
    x1: 14.1136,
    y1: 21.7288,
    x2: 18.543,
    y2: 26.1976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#5032C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#4C44C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#4175B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#2FC1A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#28E1A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_18296_168274",
    x1: 18.8717,
    y1: 18,
    x2: 18.8717,
    y2: 24.2493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0096DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#0BABCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#18C3B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#21D4AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#26DEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28E1A0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18296_168274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.5488,
    height: 12.5,
    fill: "white",
    transform: "matrix(0 1 -1 0 26 3)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_18296_168274",
    width: 232,
    height: 80,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOgAAABQCAYAAAATMDlgAAAAAXNSR0IArs4c6QAAF5tJREFUeF7tXeuPJElxz6rqnpndPWPJQlgg/h/4G/iC/w9/tLFkyxibl2XAMgeC75Ytw/owcPjgzN6T48APyT7ujA17D+52Z3d2Z6a7CkU+I7MiMyOzqh8z1y3dzXZXPiIj4xe/yMisqkYcPgcNHDSwtxpo9lGyT37sm4ORqx8uJ4jYiN0MsBHNDjoeRLuz8Z6dv2XnaRB2+ibM3fWuerS4KZbdE3aQT97+BGkxWzMjBbrxxPXDxWgmhqG1Bn5+eT8xUw6AveiTM9o2HXk9B+GmaTOWkldhk0ErluFidVZtmUq7mwfHMKyzMjYRfWcrTixgZNtm//2wStueGNteL9aia4/EzaMPenVDoOati6kwzHqqijEUBZxhMOaj/qaB5zrttTFEgYSMfxjSIKWGAmI1hUadmxCqn7ZZkJpU2qiRu7wOcypnLZZ3cLzuauZWttyA5Tgz3xa7U/KmdPE7Jx+xisAgrQKoY8NegLEa8EEPq/VjDc/Ak2uAKugisIa/WyArAzQA5U2jnJGthHk9kpsv2zwldxE+l0qO1ZOSdxtqbBMCUIDdpEyhKLiv37350RFI2QAFUA6ayiUoAWRDL/86gA5i1QchazBawz4jxQTlLISB4SJSblKRoKlld2wVFg2RGyGOlx8otV9dXg2MWme7sdEhq/uVYFJ70a+7XNyolHN6tUcXbqmCIxZyDhsnNz3H6DoWrcggfN2ULQy0zgc2fLSUOpoUQqz7tQDHAawq2VYzvSG4v3/mD2Xj2R4UW64lCHFoB7E+gKzvFVgN03nU7rGjM6S2XXoz3opWHC1vekYLX24cPSHM+g2zdG5OQNld64YGiggn4Gih1pY5NsrxcbY+oWEZVuvf170vWaw/PJ7pcNlNC6ve2UAKS+lrcSilQEbZT1je9AtTgyMk+D4uqylEXzDXoR9LPkE0KK/Jue/F/bNfyz66thOL9lgAJtp2Ib734hfEoluIN968kwboJz/2Dd0nhLGgWPMXpHXMKUEL4BW9AJaB7BQMp20AhK1oWzA5+KsWyovOJYBkSLxKr6UoAOCki1FMiAMzIakEzcUqn+zgmnIOqNF2CC+cayufdEpLnWo/1jbWc67/VO+ljibGIKvAsW1qnlL9m2sY/AbkoK8Q2Ljc2fm7Mg8DDLroTiR2lt1N8Y/P/rEdym9O/4ueKpfwMazZSwY1rKk6GmTjXXsslt0NyVjhugwm0gjleyQT2qnsV8xj5gyVOymHctdHA+Dsaz8DUIWuXhQNjzrMxVV5Cdf9uTh99CtFZE0jFu2RWC5uyRzO7Tuflg0kADpmTwAapK67dqHZESV7dKYVh255EfMlpkxGvvU9LdGkI4pphqXGvCu9Qpwlne5QDzKzLAGw4Q8LMrC2LV43+nZSQhrRaGQYxLpfiXtnvxSdjDQhsjwWkCOAbP8//OiP4gB17LmWDKmyor5CQdGG+bDAs098iTYSeCvZRgkn3mt2DnRQcs40zj11OU4srT883KS+mTn5TaqvJJwfLbMSE7JaX0qAQmgLuOm6IxmJAgn+07N/Imu+c/qf46EBQKkB2wV0IAU0Lj1jAGJoI7Rn025uUsy4ShQ/J3ZK+t17UOyzgBVsNmVuuGDLZk61Tq09M1PAuBgGqGTQ9liCFAD67X/7szxAKYNvY6dqAq0ZxtoEEK29VUzuPtvq3LJBcm5Xn1jPNXvHXFBRYw1VMDXXgXMqOd3mCOMSMagBKGRxIWq9fecvFEDv/wfNoGHnphQZwsq9HFhXBGsChn2kBpzaXM4pZ8p1pjOc0oVXl6EmWX4Kc8wm7MSGckZrmp/iXJLzZ0PsvNZj7cR2C3KqCccOW07vPXxdhrjwgWN/AE74/tRzfyl/ezsE6Pi4njMMCc6QKREw4RLX2+XVczDI3ITj6ymj5Oi6pK8pZfE2A9dWxmQx/4hie+xh31w9c9pbrQfx7sNfSFDKLE+7VH+bTnzn+c/Zrr3RhgAdMaf+ATOmLSNPQsQ/pQxQM4GxPdEpRjV33ZpxzS3DrtpTOwHzA2yO8XBAtSmAGgaFpE3TLMR3X/i85EK5K4IHZwAaAlMWlvh2xTEwZQiGwrDUZjd3evZ1Iucwhn1vY1PL120tH1I2hmXghtwc8MKchuOzBxnQhMugU26zDOI3DxSDSoDq7RZg0B+++lVxfqHuaooC1Kw3DTihsFkXYvCYBkLAUuFBTHHhmgMUtykj2XdwbCOkm0MHXEeL+6pJEpn6lMOulYHrKOYEMO4T5O77Qbx9+pped7o7nQCgd9/9d/Hz177vAxRvr4TgDENaoywMTvsbI4QJi1CKvuoMOkomTEBFzhCviq64TIRVNffY1ug8cGpKuCDGbYSADsfrsbcBqFx3aoA2ag0K59qffunLeYCapJAJbXNhbUn2zYGbNr85s7glhhEaREndFPsx/NYECF+tqhQzbUs/4c0Jo0iPSZvpg/mu1ShIh0G8df81tXCUiSIV6sJWCxy2f/qlvykAqM7WhgmhELDUQeiYB0wnlDb3yBCO/rdlLFcLVk7aOfTDmYdS/WC5Yu1DaBn7pLZWYnezUGtPFpMigJpbzQCkDdxUMgzi6Ze/VABQiXI1LAAclRCC3w1AjdeIsSC5nkCIncMASid3rvIm2uDeuZ/KfXPbmEt2L7TM34lY1e0uxwQCUxEuN0qaC6Smnbfu/Y/GlGZPeDSKNv4fvPwVGqBqvaluCZOZW8SeGJxeokgfVpA3oBLTFgISA5ACI+vgc5V5HCpdFQ0AkCk7MACvdWyY3fC/jR2y2E8rMbXGlMyKEE2VtQAF1Ogbtk2o+68/+Vseg6oY2WdOeQLIbq2o612AtBxLGkPxwKrhPYVBS0OnKX2Fk1Bj/FP6Lx2rx5C5zFPNYBh1Staf5u6oKeMMRVJPAPEPwoxB6WrlQejzamobJ2zrTc2gMjJFIIXvz7zyVQdQKoNrEc0AJ8y1enwDPespxqQ84RSjZdjIocgONMBZH04RqwTEnOcQ5dgPy+rdsB0MItXOCKASpAqsaYAaumWCE4AZrjdHWykBdkNg5sLeKZO37bolxpJzRlQYtu3xzNFfiU5K+qttF4M0xaAqSnK8OOc61IS4RQwq71ixAHUJIWrNqZJFpoxC4BRgmvrQ4q6TCSVGclXL1hr3tsc7Vc6ULdWGt/nQdxwm46OoUP/t+7+wds4Kcc2BeO66kwJoCNIRYInjghSwt20E2+iPu/6aapDbGIsf4vF7pCKGucfLde6xhFHImvI7GmLyAEJAseohYupjjvmZphxAdTyJnuFLhrhTAKpA5sexsbCVOtPLn+JDyU1qYG6wbEpWLghN/2ZccndiBCJfyqkhrakfA6bp/53TGRnUxK+WNdV61oa4eIh+OOyuUBlbv96mprOu3W0Ya24Nqrx5nfxXvVYtCLnjTm2plK41KVCHjOkxNjwU7MHr8pm4lrC0McD3H77ypGVdYbK4OQY1A5frTg1QzJyYP2MgVeV9FR72PbkmVV+u1Njre0rXxHM9RaapTmsqOGPZWbP9qBwrSi7hPVGtIg+gCBTVAMV7nwZohkUteIP5uSpAnWIsU4y51DntSs4pY5yrbikoY2t+7hYKtdZMAVNiggFMA973Hv6vPBhvEkRYTz965Wt8BrVgxCg3jzpBBxYokNbsjc41oYd2rqYGSoBYUjbUBmetaYhvTmAaOYoACg/0xSFuGLpabBLbKlRoGzuokkokxcxpG5m/XZkyZw2akm2Kge5izFSSJifHXGPET3TIgTN2IiisZ+w8F85SIe/9s//zXqeC134eg/7Bx785yJP0ifO3mEXDY36G2i2DElYXW5+adnOTdLh+vTUwJwhLNOUYUv2LC8zScNbIZMfZDOL+w//nATRMEqnO43ewqIMM6mMSRiFIMQNToS95fUfnQ0sm9FB2Pg1MBSX3LhRK4hCYJeCcwpoKNOo88OkZABTeIG9vFbOiJtegXIC6pyj4KghxNgprA43Nfdf8fCZ0aGmXGpgCwFDu2E5VrA+qPOVQ8J4nThCZstgRuN/Ur/ceviFPEoXbLHBtEkDDY3+WIUfbJwFww4MMxOxfd7DidZD02lNphDggsktQ5fqeY7ypPrhbxnMB0zBvDpxqrrXkmkGrAGrXoYybtDlhKuv+UB37HyLcnHm/v65zwVaiFQqYcXYdtxyrzwaoBmeKQZP7oCmAKkBSR/rG0BofRkizqWXhEm3vcdlw0mPOZw4jvEqObY7x5qady9JTgVnMngicMYCacDd6kqgEoPjUhAtz4+dxJcAz2r3uIW7OuA7Xeaw1RU/c9SW1BKEcr12H6oujzLD93dWG+7VgHxSvQc0zcqHfSQDFoW0NSFNA3WeAcj0zNp7ceGraDI0z18cUY6bqGplr+p1jvKRMjEHKMDQol0r8hE3iuqYtdmgr+8bn/QZx72yDADUgDYXmMmlMnzmGZczDocg11MDcoXEpMKNLFN0QlbVVDKwmA4NT3u08iDqA4mfhhutNt/fpLMA8n8gCMzAO6iwuVs7UkzT7bos5hzPV8HLtT9EPdx1d0sfU8dKMrn7l2BIXmDHiwRGAtH0GQEfnp3WdGIPCoaFnXvk7NSb4X+qgQmwP07/X05mJzSQjTZaEQhwllxgEp2xsp2MXsnDkfT+XmWFXyqovl9GlDiSkHAS59gwSQ4pO9T4oEeKap/qxAUqFrBSTKg+mrsRAGlt/lAD4KhknB+C1Bsdpm6urbTqo2vFyx5Irx9n/5AITYc2ze49VA4Ca8BYqeAwKz/WC5+LqDwugDpwmhHBM6Z+t9dWCw147WF0kF5JtE6zvN4eRM959vr6N5BK2zVx/4GjwwX9O5hazZwqgkM39wU++4t4nSIW4khETrxtU10Nguu+YTb2BJ6wgB959NiBKNo6zyRlC2C6nTeXZlcnYeWBQF7ftKfNQOt4pfcXqptbWUYZNLJ654MTsyQGoxRgGqAmd4ITgHCClBhwzBCo0njpBJUmJ6+Ygpupu1/U3MXeUjdWAEusG2gyTRdJJBps61QCF280UGNU7IrTrdX8GDVZkwV52NsGkVZM8cYHFBVqJAdSMgyMHV4bcSaRwKcGRlyMfp52SMtzxlrRZUjYXxjICDa+7GHuaO1b8wv7o7z36pXsmkVmD6if7QYg7YtAYSDlMahsr0FYMh7lQaxNhUq7P3LBqDS8HPKpf7rq+VqbcWLdxfVPOI2U7OXDG9InblG0QmduQPUGHBqASO01r3xMq16Avo/eDkq9+0PtKNtQFjWWY1IB06v5Z7AkKE4l1G3bl9cEBfcpgcP2aNSUJ7i0pMeochoF8RcgmnC5nwmtBidvmhLfUoxktg8r3g8L91yqL+/qv74g37v6UZtAUi3KZlKMYU2ZTnrJEBuXBSmscyl9VDaRAWRp1jNhTGpM6KeRs3P9ufqcACuz57KtfE5er8/kAagWZycqvA1Y4qqAMJayX8/AckHBk4bQzd5k5xpaTiaPPWlBSJ4k4a0/R9AJeJHz6+FdqDYoYFIe3JiK1J4kc4v1kkXpTCkoUEaHuLsKp6wDknIEdrm9OA1xg5sJv7GhymVsYzSB6mfWdB6DBWjQW5nLUyFmTcdrZxzI1zmLqWn0f9bDvMnFAmQMkHuMoCmCEtxRA4RSRvN2saWyC6O67P3UBAE4UKRAiFnUxLIqrHaOaUxU1k5NKhNS0d6izfxqo2QLa1ShKwGlkDB9l4skeIBjAKVk0YFAPoC99SQK1GKDmZm4JYJTVDZW56TXPdWbiXRnm+6nfqq0W6tB7kkrdRQNKv7gf4hqAtu1CfP/Fv5ZF7773aiGDWmSqrlIgxcJsGrC7Nq6S43RjZ1YTHO96xH7/4S1YMelq2Ilqi+OgoS/uvESTVTODMg/QTnTtQnzvxS/OB1AzuJJ3jGDAcjKZ+2WOB2muiwZqgEkdOPCAp0PYnI7IELftxKI9Et994fM8gAI159aiJFPqLG9OyNLr+8rEqe2CfZW5VPfXpXxyayfBmHMB0+hxBNBmIZNEbICOQjHinG5u0qxxbgiwuf6vwvV9BXDpHiVnHKVtcufP3uDBSdGODJs+RGCLJb0vbJdwpfTLrftL8eDxXb1UVMf84CQRAPRfXvic3NT01qBQMszkjthxGGd2ceIoJ2qJIktC5ly/h+sHDYw0UMuWTT0osQwUQLt2KYEKAIXPmzhJlAMoXCfDXTLGndcgON7Zeby6pMuu3ru5U0fUIPd/RaIc/1UJBH0lxpGa47lD2BwCDEDNu0EX7bEMcQGk33n+s5UAlVsrxP5oIE0Jq+YGcrhOa6DIaekmasOxkjlIybWN/otk1U/XS9WhtkhK+oiVDQG6bE/ktgiEuE89/1c0QM19oSkB1DtEexZQTTsSsKWxeo0FzqG5QxvXXwMZY9wUKP0Q91w8ePyWvIsFwlpgTgnQ7kQ89dxn6hg0CVwmu5bMftIbZ59Rv0XaKBlUWHZuRxQYH9W8OVc9ReyauhBGmk9WBgJEMVVl27KdJlhiprUlVy/rXgEUPl2z5AEUCkOiCP7W2E12jcqV/lDu2mmgKoragha2wZbUMEYA7Y5klmfZnYh/fu7T8t+jJBEGKG60BqxTdXsA+1QNHurHNLArUFIhrmHQRXcsw1v4KIBCFvdnY+iltlq2OeXqGGE+IeVCJnUI+ap9OI5oDoNye9J8nc6tSzMOPLfcsY0stcA29tFGMIO2TSeW3Q2x6G7Im9GSAFUs+o3BnGNMGVA/0KDYBePObUyH9g4a2KQGcBYXtlcAoMsFAFSI23f+PM6gLsxdy1tiFt2RvVnbCIxv4A4HMQxr+VO4xj+AdpPTfWi7RgO7PAdOA/SWzOp++86fpgGqQPr1AQA6CAVUOIYEKLcgDc4DAOPCYxxynxxQV+tVrolreR0nUXI6uooK8J7RU3eWZPKwi7f6JvcYb6AfLsXpo7uia9WDwhSD3hJtsxTf+vGnOACFbC4ArhcqlFWPaQCGVN8HcbS4JZYLtbDFOqcMzLsxW8tt6qz7eKKcY6yX63Go7aX0836DNxUzp+JbPTm8zulS+2R0qXFUnZjCJ52mKCmou+zcO1DMpfBWuFCvoQlFyydelmT7Er04v3xPXKweSeLrYB+0OxKL9sSyJ5Qlk0SUHoBN4XegZfhgkMJDj+R/8lRGL2DBC3s0R4ubXlPHyydE2wjRti5JgcHnA9x9iznbntwn47nmWKl1wtpTQOA+OnNGG5vcVOj4eJpz3bYcz6mLg/EsOzo5xT1iyXVEnDuLoAy+X1TZNN6j9dU7AqPcu1QUoKJM9B5Q3U74KE5bVj839/HFPfH44lTe/6lOEB1LFsXhbUh82UmHDO8wqBDUKLbvLzQ4pQjyGgDZKt4IHLxdWLWhgC1P8ssTFeq5LPJUf7e0zwmF5/E6e0APL5OKgfJOdO9mXnTtaLm0hVLGGd4MHDMs01jOTnPX1SSUwiM7VRsrsOp52fJwTCsiyikR8uz8gi4eUbC2Eq/Oav1YfldzrByGme++d0ur3C1phqRM3KjAiF0NnLQzXfsuyAD30cU9AU4O7N1gAOz/nfv/LR48ekf8+Odfl0OosgzI8qruVdjrAKu+G0WEr/x2Iqsa5BC0R5Lw1YxdMpGpskbSmvZgmD7je17BgV9Nu3UuHPDJY156gu2hbR0qQVRi9TTKmoODCz9O6z0DTIYJuUxWozuODmrajY/cv7Kt/nGvMX1SspiyH7jxUdvEk7c/UQ/QmDLNKSR33ZiPe1CSA7MCuPyOQH5x+cBrXgrPjW9wTQ51zWEVzDZ6HXng4hA5cD7SORBQ5NTlluHuR/LbU3M/NzikKUTWpnP3xR2rsuGxXFie0MFbpyv3SBrxxMmHR+BU+tvyZwxijgCxLA8dbiUfChU19BnbCpjufPWQM8iyMjVOq6AHpXFeOEs1a15jwOqyciwpp7Kd/vM6GsmBxnrr5PdH6jHMaS5sHaCsCdtxIeVEfKcgHSRhsJQzoMObsbGz6xIHQqg+aMdEBMHM9qjIhexXDOLm0QfRsiUdMSnGwUsj+EHXwUsfa8y6LFEGZDw5+j1G3w5Msb6lXLp/p0vV96Vev85pmreOPySbC0GJ+/gt/d3BWar+oLsAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_18296_168274",
    width: 9,
    height: 69,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAABFCAYAAACYC8wHAAAACXBIWXMAAAsSAAALEgHS3X78AAAB3klEQVRIS42WQc7qMAyEx265S4XEiiUSSAUOz65LuEqb2G/R5/xJ41AsVSz8ZTK20wZSVXjxeDxURNB1HdgDns+nhhAAACEE9B4kIhARAMCyLDU0jqOKCJZlSQuaSqqKGCNijDUkIogxYp5niAimaaLKuKomPzFGACiru91uGkJI2xlcQJaIMSawgkQEIYRk2N2OiACsDQwh4PP5EIC/6i6Xi1pSRNKCQsn6Yj7MdAVZ5CoFZNvkVVWQrSYixBh9TwAKT7lagnKjRJTKB/634Hw+p3FYA/NgAJXRXLWCvMoSZKUTUXoqCFjN5sejgmwkFm4zW+9eAdkW3lYJAr6ruS9CE9pVanmxoGEYdDv5fLgAwHvlJ2gP/M34ngoA9PnEt9O3qF4EL/pt0oP5/X6TJZlX4WEYCqPcWl1BwHewUPq5Ote4JSzZPE8/G7fwFvTbxNft7Mh8PeO7ffIiH03hqdWKok/MjK7r/K/KNE3EzGBm9/OTPBlgypVSDjVntxdFn7bP8XhUILulrDpVTROobs7X60Vd17neCk+mBiD9VtBun3IIaFxAeeRqp9NJaXt+rtdrcRcvy+IfX2ZG3/ewebrQ4XAoi/CO6/1+V2vkPM8+BKz/xoD1ym1CFuM46j9FLmGyPjfwWwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image2_18296_168274",
    width: 4,
    height: 7,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAHCAYAAAAvZezQAAAACXBIWXMAAAsSAAALEgHS3X78AAAAbUlEQVQIWyXIOxKCMBRA0Zvw5JNBTHZA52jpjPtgkS6B3v3YkSEFCcyj8JTHqCq/76Q+BPa9YAHaruMSPNa5f6xxha0gaqmmcVZpa1zdUEpG7s8HzW0gxYXr+2MkpUQ+DszwAkCWGKnyhu8zACe2FyTmf7TazAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image3_18296_168274",
    width: 5,
    height: 8,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAgElEQVQIWz2Nuw3CMABEn+04oXJBEypKBqDJAsxBgRiMFdgCIRiBFmgSmYhfATmK4DzpmqfTHZLYbypJIsWetgthLPVuLf5kk7JkOgu08ZMcto2Re9Mw8m+eh6UA7OV85RYjPsvpvn3bzldHE0LAjwM418u00z1euCIHwEjD6cAPFoQyBq5XX+0AAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image4_18296_168274",
    width: 9,
    height: 2,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAACCAYAAACKVvbTAAAACXBIWXMAAAsSAAALEgHS3X78AAAANklEQVQIWz3FsQ0AMQwCQDKD99/Le7gBYYk0+S9Od5JkZvCpKqwNe2EbXuN0d0RBIvgWBf4LF3ClM18ByXRvAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image5_18296_168274",
    width: 204,
    height: 5,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMwAAAAFCAYAAAAJxQOOAAAACXBIWXMAAAsSAAALEgHS3X78AAAAw0lEQVRIS+3VQWrDMBCF4X+QvBhlLBukCzQXSnu/2Gdoe4L0SD6BurALIYQ0bVeh84F4QiChxYwkrTX+ap7mBjDkTM6ZPGyZB3a24/31jRAjMYQfZYiBGO7NbU8IiIh8d2fnfkPuaZivhujNMDOsN8z6s/k6Pk4nuq6j1EqtlVIKy7IwjuO1Y72o3cO52jDzNLdaylb4a5ZSuHi4veDdvyPTcWpJFVVFk6KaUFVSWtee9ntvDOc2EUBEOLw8g/8azt30CeN8IvH2P1SdAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image6_18296_168274",
    width: 204,
    height: 6,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMwAAAAGCAYAAACPUXEgAAAACXBIWXMAAAsSAAALEgHS3X78AAABcUlEQVRYR+2WQVKDQBBFXyBMxWSbylKzywk0ujEeQC+h5woL9XbxBMr0dwEECCGBKt3o/Kqu6d+/u2umhgZGkkSFEQEBAZ0Yp9uUi8mEx6dHoihWFEdEUWVxHIchCggoMGp+YHKk21TJeMz1+gaXOJxLSJzDJY7EJTjncM6FQQr4dzg6MF1It6mWyyWz2Yz17fpcOoRfvIA/hkED04X31zd9fn0BsNncs9vtCvvg+eUZ7z1mNsz8YaxHj6JmfXe7j0mqfBOm0jes0GSGFVrd79TMkA79nOd929rm4QFJDQNOc4EYwoVqsd5cQnTxqqbBJeA0b/XsUdPiRZ/zPI/t98hALiEOuaC2d6GfGZjfQLpNT25ssVjgs4wsy8i8b/ir1ao6ZMOsHbNjeZXZQf18Psf7fIC9N8x7vJWrx7ztXxD19fLqCiiOpNJTy4durW/eXpMqv6H9Qo/ac9Sl9c07qw3Mm06n7bstz3zkzsvadg18AwoF7ezxQxZ4AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image7_18296_168274",
    width: 25,
    height: 5,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAFCAYAAACw/UeDAAAACXBIWXMAAAsSAAALEgHS3X78AAAAwElEQVQYV61QTQ7BUBicp4kvXegBpBcgEfs6AG6AJUviDNqy1AoNFn3d4Qi4QM/AOVh3LIRERFiYZHbzkxlFEt+wXq6YF4HWMayChf3xoABg7Hos2jYAoNvrqk9+Fc0XTNMUm932RTR2PYoI8iIQEZxPJ8SJxuV6feoMw+CwP0ClWgXwXtSsN1hzHMAfuTRNkyTxb048n51Wm7mibSNaREh0QqXU9+9+xCwImWXZ/aFHq441y6XSXxbpWDOcBs+sG3w0woW6f4MAAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image8_18296_168274",
    width: 25,
    height: 5,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAFCAYAAACw/UeDAAAACXBIWXMAAAsSAAALEgHS3X78AAAAsklEQVQYV52RQQqCUBRF7w/FgX0XYgtKW0A10hpEDaJQnBWZTeO/2pIErkBag2DwGoSBGRne6b28c+AJZsZnSBEDwD3Psd5uRGPQElLEj7LEeDoRANAjRSyE4KqsALc07QQAXnKarr9lRRIf2Zv5nY615bDbc1EU0PpS1oooCNk0TWRZBgA4k/pbYGDb7A4dSMuCtCzQ9YKR40J8+wkAzD2/UcSn5CcwCkI2DAOL1bK2ewK1tUWAA7Ia6QAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image9_18296_168274",
    width: 2,
    height: 6,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAGCAYAAADpJ08yAAAACXBIWXMAAAsSAAALEgHS3X78AAAAOklEQVQIWwXBwQmAQAxFwZcPKXAPtu82oIIL6iEkccbG2HruE1UV7o7WvXi/B53XQWag7qS7UERgJn4HmxwGQlekbQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image10_18296_168274",
    width: 4,
    height: 8,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAYAAADeM14FAAAACXBIWXMAAAsSAAALEgHS3X78AAAAW0lEQVQIW03BwQ3EIAxFwWdDQSmA/qtIBxwRFiHAz2mlnTFJ1FqVUiLnjANIorXGOQe771vuTu+dtRa+9yYiGGNwXZf58zxIwswAyO/7EhH8uCQASikG4HNO/n29CTTPcKYrYQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image11_18296_168274",
    width: 2,
    height: 6,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAGCAYAAADpJ08yAAAACXBIWXMAAAsSAAALEgHS3X78AAAANElEQVQIWwXBgQnAIAADwU+0gmALdgq7/3rSeKe1viQ/liAJtV2d7Y0lIQnP+VJc8f0MAA6TjAn5kt+WsgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image12_18296_168274",
    width: 4,
    height: 8,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAYAAADeM14FAAAACXBIWXMAAAsSAAALEgHS3X78AAAAWklEQVQIWzXMIQpAIRQF0Xny5QkWg+5/MYLVbYjNark/OfkwSGKMod67JBHmnHJ3XsHMAJAEgO29tdbi3oskQmvN3J0nA0CMkVIKKSU+gJwzALVW7M3OOTIzfiMdJ2FqEWgWAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image13_18296_168274",
    width: 4,
    height: 4,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAACXBIWXMAAAsSAAALEgHS3X78AAAAPklEQVQIWyXBsRGAIBBE0b8cM8xgBQbUSok2YmZAIrcGvqdrVB+RPIY7RUl+L9Bk6gKakpDoAtlmnt0CYm8+mWoSi6nIrsYAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image14_18296_168274",
    width: 2,
    height: 3,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAADCAYAAAC56t6BAAAACXBIWXMAAAsSAAALEgHS3X78AAAAJElEQVQIW2N88uT1/79//zIwsbAwMzAwMDAwPHz48v////8ZALpCDV+38EnTAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image15_18296_168274",
    width: 4,
    height: 4,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAACXBIWXMAAAsSAAALEgHS3X78AAAAQ0lEQVQIWwXBQQ5AMBRAwdevidpKLCx7CYd0RC5gaSeiPDNpnQcvYYqXs0leusbYP2BCIM47U75EMXE8ASp7DbcaqvxvCRvER0tV3gAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image16_18296_168274",
    width: 2,
    height: 3,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAADCAYAAAC56t6BAAAACXBIWXMAAAsSAAALEgHS3X78AAAAJElEQVQIW2N8/vzt/1+//jAw/fr1h4GZmYmBiYHhP4O0tAgjAM9/CvJito4aAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image17_18296_168274",
    width: 26,
    height: 66,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image18_18296_168274",
    width: 27,
    height: 67,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAABDCAYAAABtCX7PAAAACXBIWXMAAAsSAAALEgHS3X78AAAD/klEQVRYR72YO0s7TRSHnzPqxkuMtxi8rDZ/xYhgY2ORQtDSwtpP4Kext7EWwVYEU2glWEhKrSxcI941CLq6m3mLJJtN1MhrdnxgQw45Z3+cyZw5MyNaa74il8vp7e1tYrEYp6enABQKBXzf/9IfwLIsurq6SKfTAExNTTE0NMTExAS2bUtrfYDv+3p1dZXd3V16e3vJZDI8Pj4C4LouIgKAiNR8930fz/N4e3vj6OiIycnJmvfatg1a6/CjbdvWgAZ03W+/egC9sLCgtdaosPr6+jqO49DV1YXWWoiIWCwGUCu2ubnJ4OAgLy8vkQkB9Pb2AiGxg4MDXZkIUTM9PQ2ExA4PD2lvb+fm5ibSrMIEYtlslvb29ka+vyaRSABlsWKxqM/Pz+no6GgY9FuGh4cBaAXI5XJ8fHxwfX1tbAihnNnl5SUfHx8/+f6avr4+oCx2cnJiVKytrQ0oix0fH/P+/t4woBksywLKYvl83mhmlYmnAK6vrxkdHW0Y0AwDAwMAtLquq33f5+rq6oeQ/4+IaAClSuWsHMfB87xIF94wIyMjpfYCqIeHh4YNsRmUUsEDoJ6fn/E874ew31FproAAqLu7O6OZ1diAUbFkMlm1z87OjA3jl5l9t8Nqlk9iprozlCZIa2t1A1crHTFKqZqGrCp7QhMopYKdFfxBZqFaMy/W0tJStU3VGJTE4vF41W5paQkWyqgJnwfgD4bx09R3HOfbgGZQSjExMVG1+/r6jA5jzQQpFovGMnMch7Ozs8BWxWKxgXtziAjhRUONj483cG8OEcF13cBWJrdwIsLT01NgGxcLo4aGhr5xbR4R4e7uLrCNFnU9CjBaZ7e3t4GtPM8zVmeu69b8aerfv3/f+UZCzUJscjZCnVjlcG2KP2sxUBLLZrOl00y435hARHh5eQFAhdu2CUSEt7c3AFQsFjNWZxXu7+8BUD09PcbqDGqXLDU4OPiDe3OEe5qybZv+/v7g/Bs19VNfwmeoqBERLi4ugHKdpVKphgHNICIUCgXA8KoPdXUGBFfjJviUWTqdNpbdJ7FUKmW01oJLOK01hUIh0rv8+nv9VCpVvdfv7u6WTCZjZCi11iIieJ6ngxaztLRkbCgrhR2ILS8vV36IfCUREfL5fFVsbm5OFhcXG8X8GhHh4eGhtlNns1ls244sOxHR5Yenpyfq27RkMhm9tbXF2NiYdhyn4T1kZ2en9n0f3/eZn5/H8zw8z8P3fVZWVrBtm9fXV2ZmZkov/+oqaWdnR29sbLC/v8/e3h6e57G2tvbJr0IymSQej5NKpZidnWV+fh7LslhYWKhMjtLHD/dW+uDgIDj2WJZFW1sbw8PDJJNJEokEUn96aMB/rf72WJyt1RoAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image19_18296_168274",
    width: 2,
    height: 79,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAABPCAYAAADBcBSWAAAACXBIWXMAAAsSAAALEgHS3X78AAAA1UlEQVQoU42RQU7DMBBFX4yUE2SRDVW5B3Bx4EyuGmzFsd3PwjapkqCye/rvz8xi+J4mSZKx9gLQGWstAAdwqdBJEtCZJYSi5gZhbhDmB0pm3pXvOm3zXJXzvgBAzrlASqlCrBBTfKxakloSd+W0K8eU6CTx9fGp7dT26NGtCsMwlD1xWeqeNv4LAH+oY3g6PZ80juNWLRHzcj6XJMbI6/tbAeB/kG83ALDWKoQg452j7/u7p3jnADrjXU22CuNrQs5ZkjDTNBW1wnWXrHAF0NqJKQHwA9vX+RsbkEy5AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image20_18296_168274",
    width: 12,
    height: 16,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAQCAYAAAAiYZ4HAAAACXBIWXMAAAsSAAALEgHS3X78AAABL0lEQVQoU32SoW7CYBSFP7qmCxMlBEkwBAFhioIDN9QWkoFaES3PhEHyEEwxwRSGmb7AsKxk4IY7E9vKCH85yTV/vtycc+6PJNImiiL1ej15DU9ew5MkLFLkP/kahSMAVm+rzN+7bYKjKJJz7ZyAAE2veW6j0+koCAKZLHoNTyeWxuOxyuUy0+n0ZDNAq9mSbdvHDA/3DwKMMED9tk61VgVJBEGQtJA2k8lEkn4s7T53pqWJfN/XcrkEyFgA2ZvsWSP/5TgOxWIR+K01jmMj2H/sy825rN/XSTZr6A9VKpXO4O5dV27OpVAosHhdHA+3+diw3+0TsN1uq1KpAObGrHw+n/gf9Ac6fB0AmL/MjZmSrxGGoYCL4QHsWrVGGIbaxltmz7OLMIBtXVmp1zXpG8j/tzJ1elDEAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image21_18296_168274",
    width: 4,
    height: 5,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAFCAYAAABirU3bAAAACXBIWXMAAAsSAAALEgHS3X78AAAASUlEQVQIWwXBoQ0AIAxFwUf7w/7DMAUjYHAoEkQlJOWO1lpGRK61sveeBiCJWitmhiTh7owxiAjsvcfeG3fn3otKKcw5OecA8AEmASHNLJGd/AAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image22_18296_168274",
    width: 4,
    height: 6,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAGCAYAAADkOT91AAAACXBIWXMAAAsSAAALEgHS3X78AAAAVklEQVQIWwXBuxFAEQBFweMzoleBXA2K0K5Rj5xEaAb37ZpaqwBSSvTe8c45vu/DWksIAXvvJefMew/vPTbGyJwTSay18GMMzjnsvQEwkmitSRKlFPMDuxcon26vZ2UAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image23_18296_168274",
    width: 4,
    height: 5,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAFCAYAAABirU3bAAAACXBIWXMAAAsSAAALEgHS3X78AAAARUlEQVQIWwXBwQnAIBAAwU0I+LIaWz+wDvsQQf3fZgaViHCMocoTEbbWOOcw5+QFKKVQayUz+QDWWtx72XvzqPTezUwAfpEBKqUn91tGAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image24_18296_168274",
    width: 12,
    height: 16,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAQCAYAAAAiYZ4HAAAACXBIWXMAAAsSAAALEgHS3X78AAABlElEQVQoU4WRz+4hQRSFv+qqZtMigtgJS0tJR7yChUewsPaIxFasREgEEf8isROa6Ka6ahaGZCZmfnf9nXvuOVdYa/nfjEYjez6fCYKAZrMp1L/AXq9n8/k8hUIBpRSn0wkA5xs8nU4/tlJKns8nqVSKfr9vxd8nDQYDm8lkSKfTOM5r3+Vy4Xg8UqlU+OOk5XJpy+UyAO9FcRyjtUYIQRzHfBwOh4OVUiKlxBiDMQYA13V5PB7s93uklK8M3W7XhmH4cTLGIKVECMH9fkdrjTEG3/dfLRUKBYwxaK1xHAcpJXEcE8cxURQRhiGu6wK8MjweDzzPQymF4zhYa1FKsdvtCIKA+XyO67r4vv8SeJ5HMpnEWst4PGY2m1EsFtlsNgghsNbS6XQEgBoOhzaXy5FIJLjdbgRBgDGGxWKB67rU63VqtZp451PWWrTWHA4HjscjWmuu1yvVapVGo/EBP4IwDImiiNVqxXq9BqBUKn2FAZTjOEwmE4wxZLNZ2u32V/Aj2G63wOujP8Hwu9ZWq/Uj+J5ffu3NPythKJ8AAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image25_18296_168274",
    width: 12,
    height: 16,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAQCAYAAAAiYZ4HAAAACXBIWXMAAAsSAAALEgHS3X78AAABI0lEQVQoU41RsW6CUBQ9j8Q/sGFmRwYRV2Yfpg42qaQm8AP2G/yUl9iJpE70G1hwrBM1LGwsdTY9HSoEtNie5C4n99x3znnCHtoEgHSXCvwDWq/XgzkwsV6veTqd+KcAAJRSIs9z+L4PKeVtkTNySBLVBEHAIAhaXHM0XdcRhmF9VSklAGB2P2OTr6DNH+bYv+9bpFJKFEUBfhFXIpKQE9lpYfm0bFnUAMAZO+jC5mUjAGDqTQmcWzp8HDCyR53tKKVE/66PWrB6XnXttpAkCQX5c9h1XRqGUbd0idpBM6AnvZt/YA9tas0r8VssyrK8rvL8gjkw0RIAQBzH4vh5RBiGXDwuWkLLslBnuEQURdy+bpFlWc2lu1T86rU5ciKrXCSJb7Cz5J/g2ID1AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image26_18296_168274",
    width: 4,
    height: 6,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAGCAYAAADkOT91AAAACXBIWXMAAAsSAAALEgHS3X78AAAAUUlEQVQIWyXIIQpAIRRFwfM1KlheEve/A6sLEgwiGN81/ImDJHrvkoQkvjGGcs4AzDkJ915aa5xzAAgAZkatlVLKH2stUkrsvQkxRtwddwfgAZyQJLg2VquHAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image27_18296_168274",
    width: 4,
    height: 6,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAGCAYAAADkOT91AAAACXBIWXMAAAsSAAALEgHS3X78AAAAUUlEQVQIWzXLsREAERRF0ftZgYiAPhRPqhg1SCTeBjubnpljYwyZGfdeAJwkWmvUWj+IMVJKIaVECIHnnANAzpm9N+6/ay289yCJ3rvmnJLEC7BSInTAjHH6AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image28_18296_168274",
    width: 4,
    height: 4,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAACXBIWXMAAAsSAAALEgHS3X78AAAAQElEQVQIWwXBMQ4AIQgAwT1DQkisqCj8/y98DxUV1noz3977mRmqSmYic07WWnQ3AKOq6G5EhIhg3HsBcHfOOfzhuRV2ahNVbAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image29_18296_168274",
    width: 12,
    height: 16,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAQCAYAAAAiYZ4HAAAACXBIWXMAAAsSAAALEgHS3X78AAABl0lEQVQoU42SvYoiURBGT92+rYKNCmYKZiYGgk/gG2hgYGQkmPhCxpr5BMYm/kTSJiYmYqyBtLTt1dpgZpqdhdndLyzqcAq+kul0qgCDwUD4jxhrLQCz2Uz/sQuALJdLLRQKhGHI7XYjm80yHA5/tBlVJQgCfN/nfr9zuVyYTCY/2mS9XmuxWCSTyQAwn89xzlGtVimXy3Q6nW82UVUOh4OWSiWstZzPZ5bLJQBxHFMqlRiNRimUAsViEWstIoKqslqteD6fPB4Prtcr4/FYUiAMQw2CgHw+jzEGAOccr9eL0+nE5XIhiiL6/b6YL9X7/cY5l97qeR6qiojQaDSo1WoAGIBmsym+7+N5HiKSgrlcjnq9jrWWr75Sg+/76aKIkCQJzjne7zdRFOGcY7fbaQpUKhU5Ho/EcYy1Fs/zMMbgnENVcc59zPgt7XZbNpsNz+cTYwyZTAbP8wB4vV44574DAL1eT7bbLfv9HtWPwuM45vF40Gq1xP4JAHS7XQFYr9daqVRIkoT7/Q589vC3LBYLTZIkfZFfzBfET6uh/DcAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointCarMap);
export default __webpack_public_path__ + "static/media/point-car-map.ca25868ee898cc7155d1f384d5a9eea5.svg";
export { ForwardRef as ReactComponent };